import { notification } from "antd";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../context/UserContext";
import { changePassword } from "../../utils/api-lists/login.api";
import Input from "../Input";
import { Form, Header } from "../NewPatient/NewPatient.styles";
import { Wrapper } from "./ChangePassword.styles";

const ChangePassword = () => {
    const userContext = useContext(UserContext);
    const [oldPassword, setOldPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [repeatPassword, setRepeatPassword] = React.useState('');
    const [error, setError] = React.useState(null);
    const [success, setSuccess] = React.useState(null);
    const {t} = useTranslation('common');

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (newPassword !== repeatPassword) {
            setError(null);
            setTimeout(() => {
                setError(t("error_passwords_do_not_match"));
            }, 0);
            resetFields();
            return;
        }
    
        try {
            const email = userContext.user.email;
            await changePassword(email, oldPassword, newPassword);
            setSuccess(null);
            setTimeout(() => {
                setSuccess(t("success_password_change"));
            }, 0);
            setError(null);
            resetFields();
        } catch (err) {
            setSuccess(null);
            setError(null);
            setTimeout(() => {
                setError(t("error_invalid_password_format"));
            }, 0);
            resetFields();
        }
    };
    
    const resetFields = () => {
        setOldPassword('');
        setNewPassword('');
        setRepeatPassword('');
    };

    return (
        <Wrapper>
            <Header>
                <p>{t('change_password')}</p>
            </Header>
            {error && notification.error({
                message: t("error"),
                description: error,
                placement: "top",
                duration: 3,
            })}
            {success && notification.success({
                message: t("success"),
                description: success,
                placement: "top",
                duration: 3,
            })}
            <Form onSubmit={handleSubmit}>
                <Input type="password" name="oldPassword" placeholder={t('old_password')} value={oldPassword}
                       onChange={(e) => setOldPassword(e.target.value)} required/>
                <Input type="password" name="newPassword" placeholder={t('new_password')} value={newPassword}
                       onChange={(e) => setNewPassword(e.target.value)} required/>
                <Input type="password" name="repeatPassword" placeholder={t('repeat_password')} value={repeatPassword}
                       onChange={(e) => setRepeatPassword(e.target.value)} required/>
                <button type="submit" className="btn btn-2 btn-align-right">{t('submit')}</button>
            </Form>
        </Wrapper>
    );
}

export default ChangePassword;